// extracted by mini-css-extract-plugin
module.exports = {"select-item":"BrandsSelect__select-item___2vYVj","select-value":"BrandsSelect__select-value___158xy","input":"BrandsSelect__input___2GYTR","icon":"BrandsSelect__icon___2_AC6"};